// pt-BR strings of the web that contracts does not already carry
// (SHARED_MIC_LABEL, RECORDING_UNAVAILABLE_LABEL, EMPTY_ROOM_LABEL and
// PRESENCE_UNAVAILABLE_LABEL live in @kima-hub/contracts).
export const COPY = {
  appName: 'Kima Hub',
  loading: 'carregando\u2026',
  network: 'Sem conex\u00e3o com o servidor. Tente novamente.',
  unexpected: 'Erro inesperado. Tente novamente.',
  signInTitle: 'Entrar no Kima Hub',
  signInBody: 'Use o e-mail e a senha fornecidos pela equipe Kima.',
  signInButton: 'Entrar',
  email: 'E-mail',
  password: 'Senha',
  invalidCredentials: 'E-mail ou senha incorretos.',
  signInFailed: 'N\u00e3o foi poss\u00edvel entrar. Tente novamente.',
  signOut: 'Sair',
  sessionExpired: 'Sess\u00e3o expirada. Entre novamente.',
  refusedTitle: 'Acesso restrito \u00e0 equipe Kima.',
  refusedBody: 'Esta conta n\u00e3o faz parte da equipe ativa. Se for um engano, fale com um administrador.',
  notFound: 'P\u00e1gina n\u00e3o encontrada.',
  backHome: 'Voltar ao in\u00edcio',
  rooms: 'Salas',
  recentMeetings: 'Reuni\u00f5es recentes',
  noMeetings: 'Nenhuma reuni\u00e3o ainda.',
  loadMore: 'Carregar mais',
  search: 'Buscar',
  searchLabel: 'Buscar em transcri\u00e7\u00f5es e resumos',
  searchEmpty: 'Nenhum resultado.',
  enterRoom: 'Entrar',
  summaryHit: 'resumo',
  inProgress: 'em andamento',
  // Pre-join and room
  roomTitle: (slug: string) => `Sala ${slug}`,
  microphone: 'Microfone',
  camera: 'C\u00e2mera',
  micDevice: 'Microfone a usar',
  cameraDevice: 'C\u00e2mera a usar',
  defaultDevice: 'Padr\u00e3o do sistema',
  previewOff: 'C\u00e2mera desligada.',
  previewUnavailable: 'Pr\u00e9-visualiza\u00e7\u00e3o indispon\u00edvel neste navegador.',
  previewDenied: 'Sem acesso \u00e0 c\u00e2mera. Verifique a permiss\u00e3o do navegador.',
  headphones: 'Use fones de ouvido: sem eles, o seu microfone capta a voz dos outros e a transcri\u00e7\u00e3o fica confusa.',
  sharedMic: 'Microfone compartilhado',
  sharedMicHelp:
    'Marque se mais de uma pessoa vai falar por este dispositivo. A fala ser\u00e1 transcrita como "microfone compartilhado (falante n\u00e3o identificado)".',
  liveRecordingHint: 'H\u00e1 uma reuni\u00e3o em andamento nesta sala.',
  recordingDecidedOnEntry: 'O status da grava\u00e7\u00e3o \u00e9 confirmado ao entrar.',
  requestingToken: 'Preparando a sala\u2026',
  recordedNotice: 'Esta sala \u00e9 gravada.',
  unavailableNotice: 'Sem grava\u00e7\u00e3o dispon\u00edvel.',
  notStartedNotice: 'A grava\u00e7\u00e3o n\u00e3o come\u00e7ou. Qualquer participante pode iniciar com "Gravar".',
  unavailableReason: {
    recorder_busy: 'Outra reuni\u00e3o j\u00e1 est\u00e1 sendo gravada.',
    recorder_unavailable: 'O gravador est\u00e1 indispon\u00edvel.',
    scratch_low: 'Pouco espa\u00e7o para grava\u00e7\u00e3o no servidor.',
    not_started: 'A grava\u00e7\u00e3o ainda n\u00e3o foi iniciada.',
  },
  // In-room recording control (spec v3.8)
  record: 'Gravar',
  recording: 'Gravando',
  recordStarting: 'Iniciando\u2026',
  recordUnavailable: 'Grava\u00e7\u00e3o indispon\u00edvel no momento.',
  recordStartFailed: 'N\u00e3o foi poss\u00edvel iniciar a grava\u00e7\u00e3o. Tente novamente.',
  confirmEnter: 'Entrar na sala',
  roomNotFound: 'Sala n\u00e3o encontrada.',
  cancel: 'Cancelar',
  // Meeting page
  meeting: 'Reuni\u00e3o',
  meetingNotFound: 'Reuni\u00e3o n\u00e3o encontrada ou sem acesso.',
  processing: 'Esta reuni\u00e3o ainda est\u00e1 em processamento. A transcri\u00e7\u00e3o e o resumo aparecem quando terminarem.',
  partial: 'Processamento parcial: parte das grava\u00e7\u00f5es n\u00e3o p\u00f4de ser transcrita.',
  failed: 'N\u00e3o foi poss\u00edvel processar esta reuni\u00e3o.',
  failedTracks: 'Grava\u00e7\u00f5es com falha:',
  transcript: 'Transcri\u00e7\u00e3o',
  transcriptEmpty: 'Sem transcri\u00e7\u00e3o.',
  transcriptSegments: 'Trechos da transcri\u00e7\u00e3o',
  /** Next to a `timeline = track` time: counted from that microphone's own start. */
  trackRelative: 'tempo contado desde o in\u00edcio deste microfone, n\u00e3o da reuni\u00e3o',
  unknownSpeaker: 'participante desconhecido',
  summary: 'Resumo',
  summaryEmpty: 'Sem resumo.',
  summaryTruncated: '\u2026 (resumo truncado)',
  participants: 'Participantes',
  downloadTranscript: 'Baixar transcri\u00e7\u00e3o',
  downloadingTranscript: 'Baixando...',
  deleteMeeting: 'Apagar reuni\u00e3o',
  deleteConfirm: 'Apagar esta reuni\u00e3o, a transcri\u00e7\u00e3o e o resumo? Esta a\u00e7\u00e3o n\u00e3o pode ser desfeita.',
  deleting: 'Apagando\u2026',
} as const;
